import { render, staticRenderFns } from "./ProSelect.vue?vue&type=template&id=5d0d92eb&scoped=true&"
import script from "./ProSelect.vue?vue&type=script&lang=js&"
export * from "./ProSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProSelect.vue?vue&type=style&index=0&id=5d0d92eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d92eb",
  null
  
)

export default component.exports